module.exports = __webpack_public_path__ + "static/media/20.1c039c89.jpg";